// In-memory timing signal only. A catalogue response never proves eligibility.
// The token binds completion to the request that actually finished, not a later
// account selected while that request was in flight. Nothing is persisted.
const listeners = new Map();

export function onCatalogCompleted(accessToken, listener) {
    if (typeof accessToken !== 'string' || !accessToken || typeof listener !== 'function') return () => {};
    let group = listeners.get(accessToken);
    if (!group) { group = new Set(); listeners.set(accessToken, group); }
    group.add(listener);
    return () => {
        group.delete(listener);
        if (!group.size && listeners.get(accessToken) === group) listeners.delete(accessToken);
    };
}

export function catalogCompleted(accessToken) {
    const group = listeners.get(accessToken);
    if (!group) return;
    Array.from(group).forEach(listener => {
        try { listener(); } catch (_) { /* Optional refresh cannot break the catalogue. */ }
    });
}
